import React from 'react';
import { Hero } from '../components/sales/Hero';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { IngredientsSection } from '../components/sales/IngredientsSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { TrustProofSection } from '../components/sales/TrustProofSection';
import { JourneyTimeline } from '../components/sales/JourneyTimeline';
import { DifferentiationSection } from '../components/sales/DifferentiationSection';
import { PricingBundles } from '../components/sales/PricingBundles';
import { FAQ } from '../components/sales/FAQ';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { Footer } from '../components/sales/Footer';
export function LymphoriaXPage() {
  return <div className="min-h-screen bg-white font-sans text-[#1B5E20]" data-id="element-357">
      {/* Top Banner */}
      <div className="bg-[#10B981] text-white text-center py-3 text-sm font-bold tracking-wide" data-id="element-358">
        🔥 FREE SHIPPING ON ALL US ORDERS + 60-DAY GUARANTEE
      </div>

      <main data-id="element-359">
        <Hero data-id="element-360" />
        <BenefitsSection data-id="element-361" />
        <MechanismSection data-id="element-362" />
        <ProblemSection data-id="element-363" />
        <IngredientsSection data-id="element-364" />
        <TestimonialsSection data-id="element-365" />
        <TrustProofSection data-id="element-366" />
        <JourneyTimeline data-id="element-367" />
        <DifferentiationSection data-id="element-368" />
        <PricingBundles data-id="element-369" />
        <FAQ data-id="element-370" />
        <GuaranteeSection data-id="element-371" />
      </main>

      <Footer data-id="element-372" />
    </div>;
}